export default "__VITE_ASSET__c9437b11__"